/* TODO: 添加美东host配置 */
const host = {
    didi: 'https://api.didi.cn',
    kf: 'https://api.huaxz.cn'
};
// webx init接口版本路径path
const initPath = {
    v1: '/webx/chapter/product/init',
    v2: '/webx/v2/productInit',
    v3: '/webx/v3/productInit',
};
const xposParamsMap = {
    resname: 'rn',
    element_name: 'en',
    xspm: 'xp',
    index: 'idx',
    component_id: 'cid',
    prod_key: 'pk',
    index_key: 'idx_key',
    instance: 'inst'
};
export { host, initPath, xposParamsMap };
